module.exports = __webpack_public_path__ + "static/media/MoreApps.9129efd4.svg";